const DDI_BR = '55'

/**
 * Mascara o telefone enquanto o usuario digita.
 *
 * Descarta o excesso em vez de truncar. Colar `+5563992652066` — o formato que
 * o Cognito usa e que o usuario copia dos contatos ou do WhatsApp — truncado em
 * 11 digitos viraria `(55) 6 3992-6520`: 55 e DDD real, entao o resultado e um
 * celular plausivel de terceiro, o SMS iria embora para ele e queimaria uma das
 * 3 solicitacoes por hora. Por isso o DDI e removido quando reconhecido, e o
 * que sobrar de tamanho impossivel mantem o valor anterior, para o usuario ver
 * que a entrada nao foi aceita.
 */
export function aplicarMascaraTelefone(valor: string, anterior = ''): string {
  let digitos = valor.replace(/\D/g, '')

  if (
    (digitos.length === 12 || digitos.length === 13) &&
    digitos.startsWith(DDI_BR)
  ) {
    digitos = digitos.slice(DDI_BR.length)
  }

  if (digitos.length > 11) return anterior

  if (digitos.length <= 2) return digitos
  if (digitos.length <= 3) return `(${digitos.slice(0, 2)}) ${digitos.slice(2)}`
  if (digitos.length <= 7) {
    return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 3)} ${digitos.slice(3)}`
  }

  return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 3)} ${digitos.slice(
    3,
    7,
  )}-${digitos.slice(7)}`
}
